export default __webpack_public_path__ + "static/media/dm9.2837b392.svg";